var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2868_6122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4806 99.1143C76.6235 99.1143 98.6272 77.0471 98.6272 49.8257C98.6272 22.6044 76.6235 0.537109 49.4806 0.537109C22.3377 0.537109 0.333984 22.6044 0.333984 49.8257C0.333984 77.0471 22.3377 99.1143 49.4806 99.1143Z",
    stroke: "#231F20",
    strokeWidth: 0.665267
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6056 63.42H58.2935V63.2115L53.4704 63.003L61.5783 50.4932L69.4368 63.003L65.7362 63.2115V63.42H75.9647V63.2115L72.9294 63.003L63.6157 48.1997L72.181 34.8559L76.5468 34.6474V34.4389H66.8588V34.6474L71.682 34.8559L63.3662 47.8244L55.2583 34.8559L58.7925 34.6474V34.4389H48.7303V34.6474L51.8072 34.8559L61.3704 50.1596L53.013 63.0447L48.6472 63.2532V63.4617L48.6056 63.42ZM36.3397 64.0454C40.3313 63.5868 43.1587 62.7111 46.1108 61.335V55.1218H45.9029L43.7824 60.6678C42.3687 62.1273 39.8324 63.5034 37.0882 63.5034C28.9386 63.5034 25.6955 56.206 25.6955 48.7835C25.6955 39.0675 30.7266 34.1887 36.4645 34.1887C40.165 34.1887 42.1608 35.5231 43.7824 37.1077L45.9029 42.195H46.1108V35.9818C43.6993 34.7308 40.4977 33.7717 36.6308 33.7717C28.315 34.5223 22.3691 40.1934 22.3691 49.3256C22.3691 58.4577 29.0634 64.0037 36.2982 64.0037",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2868_6122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99.2861,
    fill: "white",
    transform: "translate(0 0.161865)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBrand);
export default __webpack_public_path__ + "static/media/top-brand.b3a0c5577c54bfb7967765e737bd0f98.svg";
export { ForwardRef as ReactComponent };